import { templateSpecialtyMessages } from './i18n';
import type {
  DocumentType,
  VersionStatus,
  SectionProcessingType,
  DocumentInclusion,
} from './types';

export const VERSION_STATUSES: VersionStatus[] = [
  'draft',
  'active',
  'archived',
  'deleted',
];

export const DOCUMENT_TYPES: DocumentType[] = [
  'SUMMARY',
  'EVALUATION',
  'PROTOCOL',
  'LITERATURE_REVIEW',
  'FOLLOW_UP_LETTER',
];

export const DOCUMENT_TYPE_MESSAGE_IDS: Record<DocumentType, string> = {
  SUMMARY: 'templateEditor.docTypeSummary',
  EVALUATION: 'templateEditor.docTypeEvaluation',
  PROTOCOL: 'templateEditor.docTypeProtocol',
  FOLLOW_UP_LETTER: 'templateEditor.docTypeFollowUpLetter',
  LITERATURE_REVIEW: 'templateEditor.docTypeLiteratureReview',
};

export const WIRE_DOCUMENT_TYPE_ALIASES: Record<string, DocumentType> = {
  summary: 'SUMMARY',
  evaluation: 'EVALUATION',
  protocol: 'PROTOCOL',
  letter: 'FOLLOW_UP_LETTER',
  literature_review: 'LITERATURE_REVIEW',
};

export const DEFAULT_DOCUMENT_TYPE: DocumentType = 'PROTOCOL';

export const SECTION_PROCESSING_TYPES: SectionProcessingType[] = [
  'STANDARD',
  'EXTENDED',
];

export const DOCUMENT_INCLUSIONS: DocumentInclusion[] = ['always', 'on_demand'];

export const TEMPLATE_SPECIALTIES = Object.keys(templateSpecialtyMessages);

export const MAX_ALWAYS_DOCUMENTS = 3;

export const CONTRACT_BUCKET_RE = /(P|AI)\s*\[([^\]]*)\]/gi;
export const PLACEHOLDER_BRACES_RE = /\{\{\s*([^}]+)\s*\}\}/g;
export const PLACEHOLDER_ANGLE_RE = /<\s*([^>]+)\s*>/g;
export const BRACKETED_CODE_RE = /\[{2,}\s*(?:[^[\]]*?)\s*\]{2,}/g;
export const MULTI_UNDERSCORE_RE = /_{2,}/g;
export const SINGLE_UNDERSCORE_RE = /(^|[\s(:;,])_(?=$|[\s),;.:])/g;
export const STRIP_INDEX_RE = /^\d+(?:[.)]|\.\d+)?\s*/;
export const SECTION_COUNT_SUFFIX_RE = /\s*\((\d+)\)\s*$/;
export const TERM_SPLIT_RE = /[|;,]/;
export const COUNT_ONLY_RE = /^\((\d+)\):?$/;
export const MALFORMED_COUNT_PREFIX_RE = /^\((\d+)\):\s*(.*)$/;
export const AI_HINT_RE = /(^|\s)(ai|ии)(\s|$)/i;
export const GENERIC_SLOT_NAME_RE =
  /^(?:__ai_)?(?:field|slot|value|param|var|variable)_?\d*$/i;
export const CYRILLIC_RE = /[А-Яа-яЁё]/;
export const SURFACE_VALUE_HINT_RE =
  /(окклюз|медиал|дистал|вестиб|небн|язычн|буккал|labial|lingual|palat|occlus|mesial|distal|buccal|facial)/i;
export const BLACK_CLASS_VALUE_RE =
  /^(?:\d+\s*класс|class\s*[ivx]+|\d+\s*class)$/i;
export const IROPZ_VALUE_HINT_RE = /(ироп|irop)/i;

export const RUSSIAN_FILLER_WORDS = new Set([
  'и',
  'или',
  'в',
  'во',
  'на',
  'по',
  'с',
  'со',
  'к',
  'ко',
  'для',
  'от',
  'под',
  'при',
  'после',
  'до',
  'из',
  'без',
  'над',
  'за',
  'перед',
  'проведена',
  'проведено',
  'проведен',
  'провести',
  'нанесение',
  'нанесена',
  'нанесен',
  'обработана',
  'обработан',
  'очищена',
  'очищен',
  'внесение',
  'внесен',
  'подготовка',
  'подготовлена',
  'подготовлен',
]);

export const GENERIC_FIELD_LABELS: Record<string, string> = {
  en: 'Description',
  ru: 'Описание',
  de: 'Beschreibung',
  es: 'Descripción',
  pt: 'Descrição',
};
